var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:{ hidden: _vm.hidden },attrs:{"small":"","dark":"","color":"rgb( 213,0,0)"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-icon',[_vm._v("filter_alt")]),_vm._v("\n  "+_vm._s(_vm.$t('parents.clear_filter'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }